import { Component, Input } from '@angular/core';
import { SelectionItem } from '../selection-item';

@Component({
  selector: 'app-selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss']
})
export class SelectionListComponent {

  @Input()
  selectionItems: SelectionItem[] = [];

  constructor() { }

  public onItemClick(selectionItem: SelectionItem): void {
    if (selectionItem.disabled) {
      return;
    }

    selectionItem.onClick();
  }
}
